
import api from "@/api/index"; //ABP API接口
import { Vue, Component, Ref } from "vue-property-decorator";
import { ElementTableView } from "@/lib/ElementTableView";
import { MessageBox } from "element-ui";

import { CardDto, UserCardDto } from "@/api/appService";

import EditCard from "./components/edit-card.vue";
import EditCardSku from "./components/edit-cardSku.vue";

@Component({
  name: "CardList",
  components: {
    EditCard,
    "edit-cardSku": EditCardSku
  }
})
export default class CardList extends ElementTableView {
  tableItems: CardDto[] = [];

  async created() {
    await this.fetchData();
  }

  // 获取表数据
  async fetchData() {
    this.table.listLoading = true;
    await api.card
      .getAll({
        keyword: this.queryForm.keyword,
        sorting: this.table.sorting,
        skipCount: this.skipCount,
        maxResultCount: this.table.pagesize
      })
      .then(res => {
        console.log(res);
        this.table.listLoading = false;
        this.tableItems = res.items!;
        this.table.totalCount = res.totalCount!;
      });
  }

  // 新建
  handleCreate() {
    (this.$refs.editForm as any).show = true;
  }

  // 编辑
  handleEdit(index: number, row: any) {
    (this.$refs.editForm as any).show = true;
    (this.$refs.editForm as any).form = row;
  }

  // 编辑SKU
  handleEditSku(row: any) {
    (this.$refs.editSkuForm as any).show = true;
    (this.$refs.editSkuForm as any).form = row;
  }

  // 删除
  async handleDelete(index: number, row: CardDto) {
    this.$confirm("你确定删除吗?", "提示").then(async () => {
      await api.card
        .delete({
          id: row.id
        })
        .then(res => {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
          this.fetchData();
        });
    });
  }

  // 更新当前页
  async current_change(e: number) {
    this.table.page = e;
    await this.fetchData();
  }

  // Table排序
  async sort(e: any) {
    console.log("sort : ", e);
    if (e.prop && e.order) {
      this.table.sorting = `${e.prop} ${e.order}`;
    }
    await this.fetchData();
  }

  // 修改一页显示的条目
  async handleSizeChange(e: number) {
    this.table.pagesize = e;
    await this.fetchData();
  }

  // 搜索
  async handleSearch() {
    await this.fetchData();
  }

  // 重置搜索
  async handleResetSearch() {
    this.queryForm = {
      keyword: "",
      from: undefined,
      to: undefined,
      isActive: undefined
    };
    await this.fetchData();
  }

  async handelOnSaved() {
    await this.fetchData();
  }
}
